import { Outlet, useLocation } from "react-router-dom";
import { LayoutProvider } from "./LayoutContext";
import { WritersLogicHeader } from "./WritersLogicHeader";
import { WritersLogicFooter } from "./WritersLogicFooter";
import {
  useReferrerSignalOnce,
  useAutoDwell,
  useRouteDwell,
} from "../../personalization/store";
import { PersonaNextSteps } from "../../personalization/PersonaNextSteps";

export function WritersLogicLayout() {
  const { pathname } = useLocation();

  // Site-wide adaptive intelligence, all local to the browser: seed the visitor persona
  // from the first-touch referrer, credit the topic of whatever page they're reading, and
  // auto-track dwell on any [data-topic] element on any page.
  useReferrerSignalOnce();
  useRouteDwell(pathname);
  useAutoDwell(pathname);

  return (
    <LayoutProvider>
      <div className="page-shell bg-surface-dark bg-grain">
        <div className="ambient-bg" aria-hidden="true" />
        <WritersLogicHeader />
        <Outlet />
        <PersonaNextSteps />
        <WritersLogicFooter />
      </div>
    </LayoutProvider>
  );
}
